import { 
    SET_LOADING,
    SET_LIST_TYPE,
    SET_IS_SELECT_MODE,
    SET_SELECTED_ARTISTS,
    SET_SHOWCASE_ARTISTS_LIST,
    SET_SHOWCASE_ARTISTS_LIST_META,
    APPEND_SHOWCASE_ARTISTS_LIST,
    SET_FAVORITE_ARTISTS_LIST,
    SET_FAVORITE_ARTISTS_LIST_META,
    APPEND_FAVORITE_ARTISTS_LIST,
    SET_ARTIST_SELECTED,
    SET_ARTIST_WORKDONE_LIST,
    SET_ARTIST_SHOW_MEDIA,
    SET_ARTIST_SELECTED_META,
    SET_ARTIST_NOTES_LIST
} from "../../actions/artist/types";

const INITIAL_STATE = {
    loading: false,
    showcaseArtistList: [],
    showcaseArtistListMetaData: {
        loading: false, hasMore: true
    },
    favoriteArtistList: [],
    favoriteArtistListMetaData: {
        loading: false, hasMore: true
    },
    listType: 'grid',
    isSelectMode: false,
    selectedArtists: [],
    artistSelected: null,
    workDoneList: [],
    artistSelectedMeta: null,
    artistShowMedia: [],
    artistNotesList: []
}

const ArtistReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_SHOWCASE_ARTISTS_LIST: {
            return {
                ...state,
                showcaseArtistList: action.payload
            }
        }
        case SET_SHOWCASE_ARTISTS_LIST_META: {
            return {
                ...state,
                showcaseArtistListMetaData: action.payload
            }
        }
        case APPEND_SHOWCASE_ARTISTS_LIST: {
            return {
                ...state,
                showcaseArtistList: [ ...state.showcaseArtistList, ...action.payload]
            }
        }
        case SET_FAVORITE_ARTISTS_LIST: {
            return {
                ...state,
                favoriteArtistList: action.payload
            }
        }
        case SET_FAVORITE_ARTISTS_LIST_META: {
            return {
                ...state,
                favoriteArtistListMetaData: action.payload
            }
        }
        case APPEND_FAVORITE_ARTISTS_LIST: {
            return {
                ...state,
                favoriteArtistList: [ ...state.favoriteArtistList, ...action.payload]
            }
        }
        case SET_IS_SELECT_MODE: {
            return {
                ...state,
                isSelectMode: action.payload
            }
        }
        case SET_SELECTED_ARTISTS: {
            return {
                ...state,
                selectedArtists: action.payload
            }
        }
        case SET_ARTIST_SELECTED: {
            return {
                ...state,
                artistSelected: action.payload
            }
        }
        case SET_ARTIST_SELECTED_META: {
            return {
                ...state,
                artistSelectedMeta: action.payload
            }
        }
        case SET_ARTIST_SHOW_MEDIA: {
            return {
                ...state,
                artistShowMedia: action.payload
            }
        }
        case SET_ARTIST_WORKDONE_LIST: {
            return {
                ...state,
                workDoneList: action.payload
            }
        }
        case SET_ARTIST_NOTES_LIST: {
            return {
                ...state,
                artistNotesList: action.payload
            }
        }
        case SET_LIST_TYPE: {
            return {
                ...state,
                listType: action.payload
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default ArtistReducer;